import { MDBBtn, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { useRouter } from "next/router";
import { FC, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { slugify } from "@/utils/searchUtils";
import TagManager from "react-gtm-module";
import {
    createGA4ItemFromBlog,
    viewItemList,
} from "@/utils/analytics/tagmanager";
import styles from "../../styles/home/Home.Italianstories.module.scss";
import {
    italianStoriesSubTitle,
    italianStoriesTitle,
} from "../../utils/mockData/homeMocks";
import SectionCarouselLayout from "../common/SectionCarouselLayout";
import CardStories from "./cards/CardStories";
import {
    SectionsTitleText,
    TBreackpointsCarousel,
} from "../../models/common/common";
import { ItalianStoriesResponseTo } from "../../models/italianStory";

const ItalianStories: FC<{
    sectionTitle?: SectionsTitleText[];
    sectionSubTitle?: SectionsTitleText[];
    content: ItalianStoriesResponseTo[];
    isFromHome?: boolean;
}> = ({
    content,
    sectionTitle = undefined,
    sectionSubTitle = undefined,
    isFromHome = false,
}) => {
    const router = useRouter();
    const loadMorePath = "/italian-stories";
    const carouselRef = useRef();

    const [googleEventSend, setGoogleEventSend] = useState<boolean>(false);
    const googleEventSendRef = useRef(false);

    const breackPointCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: 1.1,
            height: 533,
            spaceBetween: 10,
        },
        576: {
            slidesPerView: 1.1,
            height: 533,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,
            height: 533,
            spaceBetween: 12,
        },
        992: {
            slidesPerView: 3,
            height: 533,
            spaceBetween: 12,
        },
        1200: {
            slidesPerView: 3,
            height: 533,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 32,
            height: 568,
        },
        1600: {
            slidesPerView: 3,
            spaceBetween: 32,
            height: 568,
        },
        1920: {
            slidesPerView: 4,
            spaceBetween: 32,
            height: 568,
        },
    };

    // eslint-disable-next-line sonarjs/cognitive-complexity
    useEffect(() => {
        if (carouselRef?.current) {
            const intersectionObserver = new IntersectionObserver(
                ([entry]) => {
                    // TODO vanno inviati solo quelli visibili ??
                    if (entry.isIntersecting && !googleEventSendRef.current) {
                        TagManager.dataLayer(
                            viewItemList(
                                isFromHome ? "homepage" : "italian-story",
                                isFromHome
                                    ? "Pagina Home"
                                    : "Pagina Italian Story",
                                content.map((blog, index) =>
                                    createGA4ItemFromBlog(
                                        isFromHome
                                            ? "homepage"
                                            : "italian-story",
                                        isFromHome
                                            ? "Pagina Home"
                                            : "Pagina Italian Story",
                                        blog,
                                        index
                                    )
                                )
                            )
                        );
                        setGoogleEventSend(true);
                    }
                },
                {
                    threshold: 0.5,
                }
            );

            intersectionObserver.observe(carouselRef?.current);

            return () => intersectionObserver.disconnect();
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => {};
    }, [carouselRef]);

    useEffect(() => {
        if (googleEventSend) {
            googleEventSendRef.current = googleEventSend;
        }
    }, [googleEventSend]);

    return (
        <MDBContainer
            fluid
            className={`${styles.container} py-5 px-0`}
            ref={carouselRef}
        >
            <SectionCarouselLayout
                visibleSlides={3}
                sectionTitle={sectionTitle ?? italianStoriesTitle}
                sectionSubTitle={sectionSubTitle ?? italianStoriesSubTitle}
                breakpointsCarousel={breackPointCarousel}
                isCarouselContained
            >
                {_.orderBy(content, ["createdAt"], ["desc"]).map(el => (
                    /* eslint-disable no-underscore-dangle */
                    <CardStories
                        key={el._id}
                        content={el}
                        onClick={() => {
                            router.push({
                                pathname: "/italian-stories/[slug]",
                                query: {
                                    slug: slugify(el.title),
                                },
                            });
                        }}
                    />
                    /* eslint-enable no-underscore-dangle */
                ))}
            </SectionCarouselLayout>

            <MDBRow className="d-flex justify-content-center">
                <MDBCol size={10} className="d-flex px-3">
                    <MDBBtn
                        className={`${styles.buttonLoad} shadow-0`}
                        onClick={() => {
                            router.push(loadMorePath);
                        }}
                    >
                        Load More
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default ItalianStories;
